import React from "react";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiPython,
} from "react-icons/di";
import {
  SiPytorch,
  SiLinux,
  SiVisualstudiocode,
  SiPostman,
  SiVuedotjs,
  SiPycharm,
} from "react-icons/si";

const techStack = [
  { icon: <DiJavascript1 />, label: "JavaScript" },
  { icon: <DiNodejs />, label: "Node.js" },
  { icon: <DiReact />, label: "React" },
  { icon: <DiPython />, label: "Python" },
  { icon: <SiPytorch />, label: "PyTorch" },
];

const tools = [
  { icon: <SiLinux />, label: "Linux" },
  { icon: <SiVisualstudiocode />, label: "VS Code" },
  { icon: <SiPostman />, label: "Postman" },
  { icon: <SiVuedotjs />, label: "Vue.js" },
  { icon: <SiPycharm />, label: "PyCharm" },
];

function SkillGrid({ items }) {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-5 gap-6">
      {items.map((item, i) => (
        <div
          key={i}
          className="flex flex-col items-center gap-2 group"
        >
          <span className="tech-icon text-4xl text-neutral-500 group-hover:text-accent">
            {item.icon}
          </span>
          <span className="text-xs text-neutral-600 group-hover:text-neutral-400 transition-colors">
            {item.label}
          </span>
        </div>
      ))}
    </div>
  );
}

function Skills() {
  return (
    <section id="skills" className="py-24 px-6">
      <div className="fade-section max-w-3xl mx-auto">
        <h2 className="text-sm font-medium text-accent uppercase tracking-widest mb-4">
          Skills
        </h2>
        <h3 className="text-3xl md:text-4xl font-bold text-white mb-12">
          Tech & Tools
        </h3>

        <div className="mb-12">
          <h4 className="text-sm text-neutral-500 uppercase tracking-wider mb-6">
            Languages & Frameworks
          </h4>
          <SkillGrid items={techStack} />
        </div>

        <div>
          <h4 className="text-sm text-neutral-500 uppercase tracking-wider mb-6">
            Tools
          </h4>
          <SkillGrid items={tools} />
        </div>
      </div>
    </section>
  );
}

export default Skills;
